import { combineReducers } from 'redux';

import assignedGuardianList from './assigned-guardian-list-req';
import documentsCompletion from './documents-completion-req';
import assignment from './assignment-fetch-req';
import documentsUpload from './documents-upload-req';
import documentsDelete from './documents-delete-req';
import documentsList from './documents-fetch-list-req';
import generalInfo from './general-info-req';
import personalInfo from './personal-info-req';
import relationship from './relationship-req';
import progress from './progress';

export default combineReducers({
  assignedGuardianList,
  documentsCompletion,
  documentsUpload,
  assignment,
  documentsDelete,
  documentsList,
  generalInfo,
  personalInfo,
  relationship,
  progress,
});



// WEBPACK FOOTER //
// ./src/redux/dependentForm/index.js